import { SHOW_MODAL, HIDE_MODAL, SET_MODAL_BUTTON_LOADING } from '../constants';

const initialState = {
  open: false,
  title: "",
  message: "",
  autoClose: false,
  autoCloseTime: 3000,
  onYes: null,
  onNo: null,
  yesLabel: "Ok",
  noLabel: "Cancel",
  yesType: "normal", 
  loadingBtn: null, 
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        ...state,
        open: true,
        ...action.payload,
      };

    case HIDE_MODAL:
      return initialState;

    case SET_MODAL_BUTTON_LOADING:
      return {
        ...state,
        loadingBtn: action.payload, // "yes" or "no"
      };

    default:
      return state;
  }
};

export default reducer;
